export default {
      id: "hamburger-close-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#hamburger-close",
      toString: function () {
        return this.url;
      }
    }